import axios from 'axios'

// 创建axios对象
// http://127.0.0.1:1101
// https://api.holdendata.com
let service = axios.create({
  baseURL: 'https://api.holdendata.com', // 请求接口的域名
  // baseURL: 'http://121.40.71.186:8801', // 请求接口的域名
  // baseURL: 'http://betai.holdendata.com', // 请求接口的域名


  timeout: 90000 // 请求的超时
})

// 添加请求拦截器,
service.interceptors.request.use(
  request => {
    // 设置请求的头信息
    request.headers = {
      'Content-Type': 'application/json;charset=utf-8'
    } 
    return request
  },
  error => {
    Promise.reject(error)
  }
)


// 添加响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    Promise.reject(error)
  }
)

export default service